import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0f019a89"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "title"
};
var _hoisted_2 = {
  class: "cont"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" 查看评议 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_table = _resolveComponent("el-table");

  var _component_Pagination = _resolveComponent("Pagination");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "民主评议",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(_ctx.listtit.title), 1), _createElementVNode("span", null, "开始时间:" + _toDisplayString(_ctx.listtit.createTime) + "    结束时间:" + _toDisplayString(_ctx.listtit.endTime), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_table, {
    data: _ctx.tableData,
    style: {
      "width": "100%"
    },
    "show-header": false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "participantName",
        label: "participantName",
        width: "740"
      }), _createVNode(_component_el_table_column, {
        width: "100"
      }, {
        default: _withCtx(function (scoped) {
          return [_createVNode(_component_el_button, {
            type: "text",
            class: "btn_detail",
            onClick: function onClick($event) {
              return _ctx.hisoryDelete(scoped.row);
            }
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 2
          }, 1032, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"]), _createVNode(_component_Pagination, {
    pagesize: 10,
    "total-num": _ctx.totalNumTwo,
    onChangPage: _ctx.changPageTwo
  }, null, 8, ["total-num", "onChangPage"])])])], 64);
}